import * as React from 'react';
import { SVGProps } from 'react';

const IconBookStrokedSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 2a2 2 0 0 1 2 2v20a2 2 0 0 1-1.796 1.99L21 26H7l-.204-.01a2 2 0 0 1-1.785-1.786L5 24V4a2 2 0 0 1 2-2h14ZM7 24h14v-1H10a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h11V4h-7v11l-2.5-1L9 15V4H7v20Z"
    />
  </svg>
);
export default IconBookStrokedSizeL;
